import type { TOC } from '@ember/component/template-only';

import type { CustomEmberTableColumn } from '../../../../types/components/prism/table.ts';

interface PrismTableCellsTdTitleAttributeSignature {
  Args: {
    cellData: string;
    column: CustomEmberTableColumn;
  };
}

const PrismTableCellsTdTitleAttribute = <template>
  <div
    class={{if @column.hasLineClampTwo "line-clamp-2" "truncate"}}
    title={{@cellData}}
  >
    {{@cellData}}
  </div>
</template> satisfies TOC<PrismTableCellsTdTitleAttributeSignature>;

export default PrismTableCellsTdTitleAttribute;
